import { useEffect } from 'react';

interface SupportWidgetParams {
  orgName: string | undefined;
  isMenuExpanded: boolean;
}

export const useSupportWidget = (params: SupportWidgetParams): void => {
  const { orgName, isMenuExpanded } = params;

  useEffect(() => {
    if (orgName) {
      const supportWidgetEl: HTMLElement = document.querySelector('pl-support-widget');
      const styleEl = document.createElement('style');

      styleEl.textContent = `
        :host {
          .pl-ticket {
            bottom: ${isMenuExpanded ? '10' : '2'}px !important;
            left: ${isMenuExpanded ? '20' : '9'}px !important;
            color: #0b0b0b;
            
            .pl-ticket__btn-open svg {
              height: ${isMenuExpanded ? '70' : '50'}px;
              width: ${isMenuExpanded ? '70' : '50'}px;

              > g {
                g path {
                  transition: opacity 0.2s;
                }

                > path {
                  transition: visibility 0.15s;
                  
                  &:first-of-type {
                    visibility: visible;
                  }

                  &:last-of-type {
                    visibility: hidden;
                  }
                }
              }

              &:hover {
                > g {
                  g path {
                    opacity: 0.8;
                  }

                  > path {
                    &:first-of-type {
                      visibility: hidden;
                    }

                    &:last-of-type {
                      visibility: visible;
                    }
                  }
                }
              }
            }

            .pl-ticket__form {
              width: 538px !important;

              .pl-ticket__header {
                display: block;
                padding-top: 34px;
                padding-bottom: 4px;
                text-align: center;
                font-size: 24px;
                color: inherit;
                border-bottom: 0;

                .pl-ticket__btn-hide {
                  position: absolute;
                  top: 17px;
                  right: 17px;
                  font-size: 28px;
                  color: #ccced7;
                }
              }

              .pl-ticket__body {
                padding: 18px 34px;

                .pl-ticket__field {
                  position: relative;

                  & + & {
                    margin-top: 18px;
                  }

                  .pl-ticket__input {
                    color: inherit;
                    border-color: #b3b5c2;
                    border-radius: 0;

                    &::placeholder {
                      color: rgba(2, 9, 53, 0.5);
                    }

                    &:focus {
                      border-color: #0251f7;
                    }

                    &[readonly] {
                      color: #1b2249;
                      background-color: #e6e6eb;
                      border-color: #b3b5c2 !important;
                    }
                  }

                  &.pl-ticket__field_invalid .pl-ticket__input {
                    color: #ff233a;
                    border-color: #ff233a;
                  }

                  .pl-ticket__field-error {
                    position: absolute;
                    top: 9px;
                    right: 0;
                    padding: 6px 12px;
                    font-size: 12px;
                    color: #fff;
                    background-color: #ff233a;
                    margin-top: 0;

                    svg {
                      display: none;
                    }
                  }
                }

                .pl-ticket__attachments {
                  max-height: 86px;
                  margin-top: 18px;
                  margin-bottom: 6px;

                  .pl-ticket__attachment {
                    padding: 4px 8px;
                    font-size: 12px;
                    color: #303036;
                    background-color: #e9f3fe;
                    border-radius: 0;

                    & + & {
                      margin-top: 4px;
                    }

                    .pl-ticket__remove-attachment-btn {
                      color: #020935;
                    }
                  }
                }

                .pl-ticket__attachments-error {
                  gap: 6px;
                  font-size: 13px;
                  color: #ff233a;

                  path {
                    fill: #ff233a;
                  }
                }

                .pl-ticket__dropzone {
                  padding-top: 13px;
                  padding-bottom: 13px;
                  justify-content: center;
                  gap: 4px;
                  font-size: 12px;
                  color: #303036;
                  border: 1px dashed #e6e6eb;
                  border-radius: 0;
                  margin-top: 12px;

                  svg {
                    display: none;
                  }

                  label {
                    color: #2e55a3;
                    text-decoration: none;
                  }
                }
              }

              .pl-ticket__btn-container {
                padding: 0 34px 34px;
                border-top: 0;

                .pl-ticket__btn-submit {
                  height: 50px;
                  width: 94px;
                  padding: 0;
                  color: #fff;
                  text-transform: uppercase;
                  background-color: #0251f7;
                  border-radius: 0;
                }
              }
            }

            .pl-ticket__success-screen-content {
              h1 {
                margin: 20px 0 8px;
              }

              p {
                margin: 8px 0 18px;
              }

              button {
                height: 50px !important;
                width: 94px;
                padding: 0 !important;
                color: #fff !important;
                text-transform: uppercase;
                background-color: #0251f7 !important;
                border-width: 0 !important;
                border-radius: 0 !important;
              }
            }
          }
        }
      `;

      setTimeout(() => {
        supportWidgetEl.style.visibility = 'visible';
        supportWidgetEl.shadowRoot.append(styleEl);
      }, 500);
    }
  }, [orgName, isMenuExpanded]);
};
